declare namespace $ {

	type __shm_hitalama_vk_posts_multi_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_vk_posts_multi['collect'] >[0]
		,
		Parameters< $shm_hitalama_vk_posts_multi['Posts_by_owner'] >[0]
	>
	type __shm_hitalama_vk_posts_multi_2 = $mol_type_enforce<
		Parameters< $shm_hitalama_vk_posts_multi['collect'] >[1]
		,
		Parameters< $shm_hitalama_vk_posts_multi['Posts_by_owner'] >[0]
	>
	type __shm_hitalama_vk_posts_multi_3 = $mol_type_enforce<
		Parameters< $shm_hitalama_vk_posts_multi['dto_by_owner'] >[0]
		,
		Parameters< $shm_hitalama_vk_posts_multi['Posts_by_owner'] >[0]
	>
	type __shm_hitalama_vk_posts_multi_4 = $mol_type_enforce<
		Parameters< $shm_hitalama_vk_posts_multi['posts_pending'] >[0]
		,
		Parameters< $shm_hitalama_vk_posts_multi['Posts_by_owner'] >[0]
	>
	type $shm_hitalama_vk_posts__token_str_shm_hitalama_vk_posts_multi_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_multi['token_str'] >
		,
		ReturnType< $shm_hitalama_vk_posts['token_str'] >
	>
	type $shm_hitalama_vk_posts__owner_id_shm_hitalama_vk_posts_multi_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_multi['owner_id'] >
		,
		ReturnType< $shm_hitalama_vk_posts['owner_id'] >
	>
	export class $shm_hitalama_vk_posts_multi extends $mol_ghost {
		token_str( ): string
		owner_id( id: any, next?: string ): string
		collect( id: any, next?: ReturnType< ReturnType< $shm_hitalama_vk_posts_multi['Posts_by_owner'] >['collect'] > ): ReturnType< ReturnType< $shm_hitalama_vk_posts_multi['Posts_by_owner'] >['collect'] >
		dto_by_owner( id: any): ReturnType< ReturnType< $shm_hitalama_vk_posts_multi['Posts_by_owner'] >['dto'] >
		posts_pending( id: any): ReturnType< ReturnType< $shm_hitalama_vk_posts_multi['Posts_by_owner'] >['pending'] >
		owner_ids( ): readonly(string)[]
		Posts_by_owner( id: any): $shm_hitalama_vk_posts
		post_id( id: any): string
		post_date( id: any): string
		post_likes( id: any): string
		post_reposts( id: any): string
		post_comments( id: any): string
		post_views( id: any): string
	}
	
}

//# sourceMappingURL=multi.view.tree.d.ts.map